module.exports = __webpack_public_path__ + "img/nalkip.5638abca.svg";